import React from 'react';
import { createRoot } from 'react-dom/client';
import ResponseTime from './components/ResponseTime';
import TransicionSaneamiento from './components/TransicionSaneamiento';
import ProintecaVsTradicional from './components/ProintecaVsTradicional';
import HeroInteractive from './components/HeroInteractive';

// Montar Urgencia Operacional (ResponseTime)
const urgenciaContainer = document.getElementById('react-urgencia-root');
if (urgenciaContainer) {
  const root = createRoot(urgenciaContainer);
  root.render(<ResponseTime />);
}

// Montar Transición Energética y Saneamiento
const transicionContainer = document.getElementById('react-transicion-root');
if (transicionContainer) {
  const root = createRoot(transicionContainer);
  root.render(<TransicionSaneamiento />);
}

// Montar Tabla Comparativa de Impacto Ambiental
const comparativaContainer = document.getElementById('react-comparativa-root');
if (comparativaContainer) {
  const root = createRoot(comparativaContainer);
  root.render(<ProintecaVsTradicional />);
}


